import styled from 'styled-components';

export const ScoreDateInfo = styled.div`
  color: #808080;
  font-size: 0.8rem;
  white-space: nowrap;
`;
